import type AuthConnector from "../data/authConnector";
import type { IPagedResults, IPagination } from "../data/types";
import type EventBus from "services/eventBus";
import RepositoryBase from "./repositoryBase";
import type { IDeleteRepository } from "./types";
import type User from "entities/user";

export default class RoleUserRepository extends RepositoryBase<AuthConnector> implements IDeleteRepository<User> {
  constructor(protected apiFactory: ReturnType<typeof AuthConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  search(roleId: string, pagination: IPagination) {
    return this.callApi(api => api.one("roles", roleId).all("user_search").post<IPagedResults<User>>(pagination));
  }

  create(entity: User, roleId: string) {
    return this.callApi(api => api.one("users", entity.id).all("roles").post({ roleId }));
  }

  delete(entity: User) {
    return this.callApi(api => api.one("users", entity.id).one("roles", entity.userRoleId).delete(entity));
  }
}
